import React, { useContext } from "react";
import { useHistory } from "react-router-dom";
import { CoreContext } from "context/CoreContext";
import ContainerAuthenticated from "containers/Authenticated";
import {
    ModeContainer,
    ModeCard,
    ModeImage,
    ModeTitle,
    ModeDescription,
    HeaderTitle
} from "./styled";

export default function DashboardModeSelection() {
    const history = useHistory();
    const { backgrounds } = useContext(CoreContext);

    const navigateToMode = (mode) => {
        if (mode === 'learning') {
            history.push('/dashboard/learning');
        } else if (mode === 'conversation') {
            history.push('/dashboard/conversation');
        } else if (mode === 'atividades') {
            history.push('/dashboard/atividades');
        }
    };

    return (
        <ContainerAuthenticated primary page={'mode-selection'}>
            <HeaderTitle>Escolha o modo de uso:</HeaderTitle>
            
            <ModeContainer>
                <ModeCard onClick={() => navigateToMode('atividades')}>
                    <ModeImage
                        src="/images/modo_atividades.png"
                        alt="Modo Atividades"
                    />
                    <ModeTitle>🎮 Atividades</ModeTitle>
                    <ModeDescription>
                        Jogue, ouça a pronúncia e ganhe estrelas nas aventuras da Lulu e do Nando!
                    </ModeDescription>
                </ModeCard>

                <ModeCard onClick={() => navigateToMode('learning')}>
                    <ModeImage
                        src="/images/modo_ensino.png"
                        alt="Aprender Idiomas"
                    />
                    <ModeTitle>📚 Aprender Idiomas</ModeTitle>
                    <ModeDescription>
                        Pratique e aprenda Inglês e Espanhol com a Lulu e o Nando da JoinKids.
                    </ModeDescription>
                </ModeCard>

                <ModeCard onClick={() => navigateToMode('conversation')}>
                    <ModeImage
                        src="/images/modo_biblia.png"
                        alt="Conversar Livremente"
                    />
                    <ModeTitle>💬 Chat Bíblico</ModeTitle>
                    <ModeDescription>
                        Bate-papo seguro e de qualidade. Tire dúvidas e faça perguntas sobre histórias e passagens bíblicas.
                    </ModeDescription>
                </ModeCard>
            </ModeContainer>
        </ContainerAuthenticated>
    );
} 